import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import PoiTypeThumbnail from '../components/PointOfInterest/PoiTypeThumbnail'
import config from '../config/config'
import PageHeroTitle from '../components/PageHeroTitle'
import BottomImage from '../components/BottomImage'
import { usePois } from '../contexts/PoisContext'

const Home = () => {
  const { t } = useTranslation()
  const { poiTypes } = usePois()
  const pageName = 'REVES_DE_BAROUSSE'

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle
        title="Rêves de Barousse"
        description={t(`${pageName}_DESCRIPTION`)}
      />

      <div className="container section py-4">
        <p className="lead">{t(`${pageName}_DETAILS`)}</p>

        <div className="row g-4">
          {config.homepagePoiTypes.map((poiTypeName) => {
            const matchedPoiType = poiTypes.find(
              (poiType) => poiType.name === poiTypeName,
            )

            return matchedPoiType ? (
              <div
                className="col-md-6 col-lg-4 d-flex"
                key={matchedPoiType.name}
              >
                <PoiTypeThumbnail poiType={matchedPoiType} />
              </div>
            ) : null
          })}
        </div>
      </div>

      <div className="container">
        <BottomImage name={pageName} />
      </div>

      <Footer />
    </div>
  )
}

export default Home
